import React from 'react'
import { NavLink } from 'react-router-dom'
import '../styles/projects.css'
import image from '../images/baner2.jpg'

const HomePage = () => {
    return (
        <div>
            <img src={image} className="w-100" alt="Responsive" />
            <h1 id="section2" className="text-center p-5">projekty.</h1>
            <div className="container max-height mb-5" id="projects">
                <div className="row">
                    <div className="col-sm">
                        <NavLink data-title="Dom w Kustrzycach" to={`/projects/0`}><img src={require('../images/DWK_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Dom w Łodzi" to={`/projects/1`}><img src={require('../images/DPL_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Dom w Zduńskiej Woli" to={`/projects/2`}><img src={require('../images/DWZ_01.jpg')} alt="" /></NavLink>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <NavLink data-title="Dom w Holendrach" to={`/projects/3`}><img src={require('../images/DH_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Dom w Zduńskiej Woli" to={`/projects/4`}><img src={require('../images/DZW_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Mieszkanie w Zduńskiej Woli" to={`/projects/5`}><img src={require('../images/MZW_01.jpg')} alt="" /></NavLink>
                    </div></div>
                <div className="row">
                    <div className="col-sm">
                        <NavLink data-title="Mieszkanie w Warszawie" to={`/projects/6`}><img src={require('../images/MSW_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Mieszkanie w Zduńskiej Woli" to={`/projects/7`}><img src={require('../images/MZ_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Pokoje dziecięce" to={`/projects/8`}><img src={require('../images/PD_01.jpg')} alt="" /></NavLink>
                    </div></div>
                <div className="row">
                    <div className="col-sm">
                        <NavLink data-title="Kuchnia Płock" to={`/projects/9`}><img src={require('../images/KP_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Aparthotel Warszawa" to={`/projects/10`}><img src={require('../images/AHW_01.jpg')} alt="" /></NavLink>
                    </div>
                    <div className="col-sm">
                        <NavLink data-title="Łazienki" to={`/projects/11`}><img src={require('../images/LAZ_01.jpg')} alt="" /></NavLink>
                    </div></div>
            </div></div>
    );
}

export default HomePage;